import { connect } from 'react-redux'
import Login from './Login'

const mapStateToProps = (state, ownProps) => ({
  returnPath: state.authorization.returnPath
})

const mapDispatchToProps = (dispatch, ownProps) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./src/routes/Login/index.js